import React, {Component} from 'react';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {ContentDispatch} from 'framework';
import {Dimmer, Loader} from 'semantic-ui-react';
import {countDependenciesToLoad, isFemaUser} from 'common/utils';
import {connect} from 'react-redux';
import _ from 'lodash';

export class SummaryPage extends Component {
  state = {
    loading: true,
    initialized: false,
  };

  componentDidMount() {
    this.initializeView();
  }

  static getDerivedStateFromProps(props, state) {
    const {dependencies, fundingOpportunityId, numLoadedSuccessfully} = props;
    const {initialized, loading} = state;

    const dependenciesToLoad = countDependenciesToLoad(
      dependencies,
      isFemaUser(_.get(props, 'auth.permissions')),
      _.get(props, 'toggles.toggles'),
      // TODO: Put entity type + entity id
      'fundingOpportunityId',
      fundingOpportunityId
    );

    if (initialized && loading && numLoadedSuccessfully === dependenciesToLoad) {
      return {
        ...state,
        loading: false,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    const {config} = this.props;
    const prevType = _.get(prevProps, 'config.configType');
    if (config && config.configType !== prevType) {
      this.setState({initialized: false, loading: true}, () => {
        this.initializeView();
      });
    }
  }

  initializeView() {
    const {config, data, init, auth, profile, toggles} = this.props;
    init({
      config,
      data,
      context: {
        auth,
        profile,
        toggles,
      },
    });
    this.setState({initialized: true});
  }

  render() {
    const {loading} = this.state;
    const listeners = _.get(this.props, 'config.payload.listeners');
    const contents = _.get(this.props, 'config.payload.contents');
    return (
      <React.Fragment>
        {!loading ? (
          <React.Fragment>
            {_.map(listeners, (listenerConfig, index) => (
              <ContentDispatch config={listenerConfig} key={index} />
            ))}
            {_.map(contents, (conf, index) => (
              <ContentDispatch key={(conf.id || 'content-') + index} config={conf} />
            ))}
          </React.Fragment>
        ) : (
          <Loader inline="centered" active>
            Loading...
          </Loader>
        )}
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  const dependencies = _.get(
    state,
    'dynamicComponent.config.payload.dependencies',
    _.get(state, 'dynamicComponent.config.dependencies')
  );

  return {
    auth: state.auth,
    profile: state.profile,
    toggles: state.toggles,
    numLoadedSuccessfully: _.get(state, 'dynamicComponent.context.numLoadedSuccessfully'),
    fundingOpportunityId: _.get(
      state,
      'dynamicComponent.context.grant.fundingOpportunityId',
      _.get(state, 'dynamicComponent.context.subGrant.fundingOpportunityId')
    ),
    dependencies,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  init: (initState) => dispatch(DynamicComponentActions.initWithState(initState)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPage);
